import { render } from "./customers-login.vue?vue&type=template&id=22046b21"
import script from "./customers-login.vue?vue&type=script&lang=js"
export * from "./customers-login.vue?vue&type=script&lang=js"

import "./customers-login.vue?vue&type=style&index=0&id=22046b21&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__